import { createFeatureSelector } from '@ngrx/store';

export const productImagesState = createFeatureSelector<OLO.State, OLO.State.ProductImage[]>('productImages');
